import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderForwardRelatedTaxiTaxi from "./billings-order-forward-related-taxi-taxi";
import BillingsOrderForwardRelatedTaxiTaxiParams from "./billings-order-forward-related-taxi-taxi-params";

const useBillingsOrderForwardRelatedTaxiTaxi = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderForwardRelatedTaxiTaxi>({
      data: [],
    });

  const load = async (
    params: BillingsOrderForwardRelatedTaxiTaxiParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiTaxi =
        await billingService.getOrderForwardRelatedTaxiTaxiBillings(
          params,
          signal,
        );

      setData(taxiTaxi);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsOrderForwardRelatedTaxiTaxi;
